export default __webpack_public_path__ + "static/playstore-435ac92f86437f34a98d09c6b951e30b.png";